import { CIAF_LANGUAGE_PREFIXES } from '@rover/constants/src/i18n/ciafLanguage';
import { normalizeLanguage } from '@rover/constants/src/i18n/language';
import type { ServiceLandingPathDescriptor } from '@rover/shared/js/hooks/useServiceLanding';
import getCountryUrlPrefixFromHostname from '@rover/utilities/getRoverBrand/getCountryUrlPrefixFromHostname';
import { union } from '@rover/utilities/regex';
import {
  getCountryUrlPrefixFromCountryCode,
  getDefaultShortLanguageByUrlPrefix,
  US_COUNTRY_URL_PREFIX,
} from '@rover/utilities/roverGeo.constants';

const CIAF_SERVICE_LANDING_REGEX = new RegExp(
  `^(?:/(?<language_prefix>${union(...CIAF_LANGUAGE_PREFIXES)}))?/(?<service_landing_slug>[^/]+)/`
);

const parseCatInAFlatServiceLandingPath = (
  path: string,
  hostname: string,
  language?: string | null,
  countryCode?: string | null
): ServiceLandingPathDescriptor => {
  const groups = CIAF_SERVICE_LANDING_REGEX.exec(path)?.groups;
  const serviceLandingSlug = groups?.service_landing_slug;
  if (!serviceLandingSlug) {
    throw new Error(`Could not parse service landing slug from path: ${path}`);
  }
  const countryUrlPrefix =
    getCountryUrlPrefixFromHostname(hostname) ??
    getCountryUrlPrefixFromCountryCode(countryCode) ??
    US_COUNTRY_URL_PREFIX;
  return {
    countryUrlPrefix,
    serviceLandingSlug,
    language:
      normalizeLanguage(groups?.language_prefix) ??
      normalizeLanguage(language) ??
      getDefaultShortLanguageByUrlPrefix(countryUrlPrefix),
  };
};

export default parseCatInAFlatServiceLandingPath;
